import React from 'react';

interface MessageSideBarProps {
    conversations: { ID: string; Title: string; CreatedAt: string }[];
    onSelectConversation: (id: string) => void;
    selectedConversationId: string | null;
}

const MessageSideBar: React.FC<MessageSideBarProps> = ({ conversations, onSelectConversation, selectedConversationId }) => {
    return (
        <div className="w-1/4 h-full bg-gray-100 p-4 overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">Conversations</h2>
            {conversations && conversations.length > 0 ? (
                <ul>
                    {conversations.map((conversation) => (
                        <li
                            key={conversation.ID}
                            className={`p-2 mb-2 cursor-pointer rounded ${selectedConversationId === conversation.ID ? 'bg-blue-500 text-white' : 'bg-white'
                                }`}
                            onClick={() => onSelectConversation(conversation.ID)}
                        >
                            <div className="font-bold">{conversation.Title}</div>
                            <div className="text-xs text-gray-400">{new Date(conversation.CreatedAt).toLocaleString()}</div>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="text-gray-500">No conversations available</p>
            )}
        </div>
    );
};

export default MessageSideBar;